import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MaLoginControlledInputClasses,
} from '@dxp-module/themes'

const miniWidgetModalControlledInputStyles = makeStyles<
  MyAccountTheme,
  object,
  MaLoginControlledInputClasses
>(
  () => ({
    root: {},
    label: {},
    helper: {},
    textField: {},
    error: {},
    inputRoot: {},
    input: {
      padding: '0 15px',
    },
    disabled: {},
    disabledNotchedOutline: {},
    notchedOutline: {},
    iconButton: {
      padding: '0 15px',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  }),
  { name: 'Modal_Login_ControlledInput' }
)

export default miniWidgetModalControlledInputStyles
